import { render, staticRenderFns } from "./speech-phrase-group-controls.vue?vue&type=template&id=c4f439da&scoped=true"
import script from "./speech-phrase-group-controls.vue?vue&type=script&lang=ts"
export * from "./speech-phrase-group-controls.vue?vue&type=script&lang=ts"
import style0 from "./speech-phrase-group-controls.vue?vue&type=style&index=0&id=c4f439da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f439da",
  null
  
)

export default component.exports